import * as Sentry from '@sentry/react';

function report(level: 'error' | 'warning', message: string, context: unknown[]): void {
  const error = context.find((value): value is Error => value instanceof Error);

  Sentry.withScope(scope => {
    scope.setLevel(level);
    scope.setExtra('context', context);
    if (error) {
      Sentry.captureException(error);
      return;
    }
    Sentry.captureMessage(message);
  });
}

export function reportClientError(message: string, ...context: unknown[]): void {
  report('error', message, context);
}

export function reportClientWarning(message: string, ...context: unknown[]): void {
  report('warning', message, context);
}
